import { createFileRoute } from "@tanstack/react-router";
import { VisitCallPage } from "@/components/app/visits/visit-call-page";

export const Route = createFileRoute("/resident-portal/visits/$visitId")({
  head: () => ({ meta: [{ title: "Video visit | People AI" }] }),
  component: ResidentVisitCall,
});

function ResidentVisitCall() {
  const { visitId } = Route.useParams();
  return <VisitCallPage kind="resident" visitId={visitId} />;
}
